module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pointsMessage paddingTop45 commonStyle"
  }, [_c('x-header', {
    attrs: {
      "left-options": {
        showBack: false
      }
    }
  }, [_vm._v("兑换详情")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', [_vm._v("兑换物品")]), _c('em', [_vm._v(_vm._s(_vm.shopList.goodsName))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("数量")]), _c('em', [_vm._v(_vm._s(_vm.shopList.goodsNum))])]), _vm._v(" "), _c('li', {
    staticClass: "con"
  }, [_vm._v(_vm._s(_vm.shopList.sendMessage))])]), _vm._v(" "), _vm._m(0, false, false)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footerPromt"
  }, [_vm._v("如有疑问，请联系客服:"), _c('a', {
    staticStyle: {
      "color": "#1957e8"
    },
    attrs: {
      "href": "tel:02865003333"
    }
  }, [_vm._v("028-65003333")]), _vm._v("，感谢您的支持！")])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53b98461","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/integralMallProject/pointsMessage.vue
// module id = xx9m
// module chunks = 7